/**
 * Driver tablet device-token storage (T1.2, 2026-06-03).
 *
 * Mirrors `kioskApi.ts`'s token helpers but uses a separate
 * localStorage key so a tablet provisioned as a driver-tablet can't
 * accidentally start working as a clock-in kiosk (or vice versa).
 *
 * Cleartext lives only in localStorage. The server hashes incoming
 * Bearer tokens server-side (see middleware/authenticateDriverTablet.ts).
 */

const STORAGE_KEY = 'jeanieiq.driverTablet.deviceToken.v1';

export function getDriverTabletToken(): string | null {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v && v.length > 0 ? v : null;
  } catch {
    return null;
  }
}

export function setDriverTabletToken(token: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch {
    /* localStorage disabled — caller may surface the error. */
  }
}

export function clearDriverTabletToken(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
